import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import ReportDetails from './edit.user';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Avatar,
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  CircularProgress,
  TableRow,
  Typography,
  makeStyles,
  Button,
} from '@material-ui/core';
import getInitials from '../../utils/getInitials';
import SkeletoLoader from '../../components/skeletoLoader';
import { useNavigate, useParams } from 'react-router-dom';
import firebaseUtility from '../../utils/firebase.utils';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2),
  },
  rounded: {
    borderRadius: '15px',
  },
}));

// eslint-disable-next-line max-len
const Results = ({
  className,
  reports,
  isLoading,
  pageIndex,
  pageSizeIndex,
  setPageSize,
  pageChanged,
  ...rest
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const classes = useStyles();
  const [limit, setLimit] = useState(pageSizeIndex);
  const [page, setPage] = useState(pageIndex);
  const [loading] = useState(isLoading);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isloading,setIsLoading]=useState(reports.length>0?false:true);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPageSize(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage || page);
    pageChanged(newPage || page);
  };

  const getLoadingSkeleton = () => <SkeletoLoader page="reports"/>;

  const userProfile=(user)=>{
    navigate(`/app/users/${user}`);

  }
  const openReportDialog = (report) => {
    navigate(`/app/reports/${report.id}`);
  };
  useEffect(() => {
    (async () => {
      if (params.id == null) {
        setOpenDialog(false);
      } else {
        const reportInfo = await firebaseUtility.GetOneDocById(
          'reports',
          params.id
        );
        setSelectedReport(reportInfo);
        setOpenDialog(true);
      }
    })();

  }, [params]);
  return (
    <>
      <Card className={clsx(classes.root, className)} {...rest}>
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Reporter Name</TableCell>
                  <TableCell>Reported  Name</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Reported On</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              {reports && reports.length > 0 ?
                <TableBody>
                  {!loading
                   ? reports.slice(0, limit).map((report) => (
                      <TableRow hover >
                        <TableCell>
                          <Box alignItems="center" display="flex">
                            <Avatar
                            style={{cursor:"pointer"}}
                              className={classes.avatar}
                              src={report.reporterProfilePicture}
                              onClick={()=>userProfile(report.reporterUid)}
                            >
                              {getInitials(report.reporterName)}
                            </Avatar>
                            <Typography color="textPrimary" variant="body1">
                            {report.reporterName}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Box alignItems="center" display="flex">
                            <Avatar
                            style={{cursor:"pointer"}}
                              className={classes.avatar}
                              src={report.reportedUser.profilePicture}
                              onClick={()=>userProfile(report.reportedUser.uid)}
                            >
                              {getInitials(report.reportedUser.name)}
                            </Avatar>
                            <Typography color="textPrimary" variant="body1">
                            {report.reportedUser.name}
                            </Typography>
                          </Box>
                        </TableCell>





                        <TableCell>{report.title}</TableCell>
                        <TableCell>{report.createAt &&moment((typeof report?.createAt === 'string'
                              ? new Date(report.createAt)
                              : new Date(report.createAt.toDate().toString())))
                              .format('dddd, MMM DD')}</TableCell>
                        <TableCell>
                          <Button
                            variant="outlined"
                            className={classes.rounded}
                            onClick={() => openReportDialog(report)}
                          >
                            View
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                    : getLoadingSkeleton()}
                </TableBody>
                :
                <TableBody >
                  <TableCell colSpan={3}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}>
                        {isloading?<CircularProgress color='#2c387e' size={30}/>:'No Results Found!'}
                  </div>
                  </TableCell>
                </TableBody>
              }
            </Table>
          </Box>
        </PerfectScrollbar>
        <TablePagination
          component="div"
          count={-1}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
        />
      </Card>
      {openDialog ? (
        <ReportDetails
          opened={openDialog}
          report={selectedReport || {}}
          closeDialog={(report) => {
            setOpenDialog(false);
            navigate(`/app/reports`);
          }}
        />
      ) : null}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  reports: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setPageSize: PropTypes.func,
  pageChanged: PropTypes.func,
  pageSizeIndex: PropTypes.number,
  pageIndex: PropTypes.number,
};

export default Results;
